// authorPlugin.js
// Plugin to automatically track authorship of inserted content

import {Plugin} from "prosemirror-state";

/**
 * Create a plugin that automatically marks inserted content with the author
 * @param {Object} user - User object with uid or id
 * @returns {Plugin} ProseMirror plugin
 */
export function authorPlugin(user) {
    return new Plugin({
        appendTransaction(transactions, _oldState, newState) {
            let tr = null;
            const authorMark = newState.schema.marks.author;
            if (!authorMark) return null;

            const userId = user?.uid ?? user?.id;
            if (!userId) return null;

            for (let i = 0; i < transactions.length; i++) {
                const tx = transactions[i];

                // Ignore remote Yjs changes
                if (tx.getMeta && tx.getMeta("y-sync$")) continue;
                // Skip if explicitly marked to skip author plugin
                if (tx.getMeta && tx.getMeta("skipAuthorPlugin")) continue;
                // Skip blockIdPlugin's output — those steps contain no real content
                if (tx.getMeta && tx.getMeta("add-block-ids")) continue;
                if (!tx.docChanged) continue;

                // eslint-disable-next-line no-loop-func
                tx.mapping.maps.forEach((map) => {
                    map.forEach((_oldStart, oldEnd, newStart, newEnd) => {
                        const inserted = newEnd - newStart;

                        // Only mark pure inserts
                        if (inserted > 0) {
                            if (!tr) tr = newState.tr;
                            tr.removeMark(newStart, newEnd, authorMark);
                            tr.addMark(newStart, newEnd, authorMark.create({userId}));
                        }
                    });
                });
            }

            if (!tr) return null;

            // Do not pollute the undo stack with author-mark housekeeping steps.
            tr.setMeta("addToHistory", false);
            // Prevent this transaction from being re-processed by authorPlugin itself.
            tr.setMeta("skipAuthorPlugin", true);
            return tr;
        },
    });
}
